export interface IOccupierService{
    occupierServicesId: number;
    productType: string;
    category?: string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IOccupierService = {
    getDefault(): IOccupierService {
      return {
        occupierServicesId: 0,
        productType: '',
        category: '',
      };
    },
  };

  export interface IOccupierServiceRes {
      records: IOccupierService[];
      totalRecordCount: number;
  }